import { observable, action } from 'mobx'
import QuestionChallenge from './QuestionChallenge/Challenge'
import ChoicesChallenge from './ChoicesChallenge/Challenge'
import ImageChoicesChallenge from './ImageChoicesChallenge/Challenge'
import ImageChallenge from './ImageChallenge/Challenge'
import PrerealtimeChallenge from './PrerealtimeChallenge/Challenge'
import RealtimeChallenge from './RealtimeChallenge/Challenge'

const CHALLENGE_CLASS_MAP = {
  question: QuestionChallenge,
  choices: ChoicesChallenge,
  image_choices: ImageChoicesChallenge,
  image: ImageChallenge,
  prerealtime: PrerealtimeChallenge,
  realtime: RealtimeChallenge
}

export default class MultiFactorAuthState {
  @observable challenge
  @observable submitting

  constructor ({ provider }) {
    this.provider = provider
    this.account = provider.account
    this.quovoAPI = provider.quovoAPI
  }

  answerChallenge () {
    // I actually love this trick despite its.. well, dirtiness I suppose.
    return new Promise((resolve) => {
      this.done = resolve
      this.fetchChallenges()
    })
  }

  async fetchChallenges () {
    const challenges = await this.quovoAPI.getChallenges(this.account.id).then(r => r.challenges)
    // Dummy challenge for image_choices (Quovo has no test brokerage with these), fuckers..
    // const challenges = [{
    //   id: 1,
    //   image_choices: [{
    //     source: 'https://d13yacurqjgara.cloudfront.net/users/942421/screenshots/2970032/011_1x.png'
    //   }, {
    //     source: 'https://d13yacurqjgara.cloudfront.net/users/942421/screenshots/2969038/010_1x.png'
    //   }, {
    //     source: 'https://d13yacurqjgara.cloudfront.net/users/310724/screenshots/2687157/800x600_1x.jpg'
    //   }],
    //   should_answer: true,
    //   type: 'image_choices',
    //   question: 'Which image do you think has the most swag?'
    // }]
    const challengeToAnswer = challenges.find(c => c.should_answer)
    if (!challengeToAnswer) {
      // This can happen if we have answered the challenge but not created a new sync yet,
      // OR if we are still waiting for the sync status to change.
      this.done()
      return
    }

    this.setChallenge(challengeToAnswer)
  }

  @action setChallenge (challenge) {
    const Challenge = CHALLENGE_CLASS_MAP[challenge.type]
    this.challenge = new Challenge({ challenge })
  }

  async submitAnswer () {
    this.setSubmitting(true)
    try {
      await this.quovoAPI.answerChallenge({
        challengeId: this.challenge.id,
        answer: this.challenge.answer,
        question: this.challenge.question
      })
      this.done()
    } finally {
      this.setSubmitting(false)
    }
  }

  @action setSubmitting (submitting) {
    this.submitting = submitting
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/MultiFactorAuthState.js